import { render } from "./SideHeader.vue?vue&type=template&id=cd6d395a&scoped=true"
import script from "./SideHeader.vue?vue&type=script&lang=js"
export * from "./SideHeader.vue?vue&type=script&lang=js"

import "./SideHeader.vue?vue&type=style&index=0&id=cd6d395a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd6d395a"]])

export default __exports__